import { createSlice } from '@reduxjs/toolkit';

import { initialSettings, ISettings } from './models';

interface IState {
  settings: ISettings;
}

const initialState: IState = {
  settings: initialSettings
};

const videoReadingSettingsSlice = createSlice({
  name: 'videoReadingSettings',
  initialState,
  reducers: {
    /**
     * Обновление таймера
     * @param state Состояне
     * @param root0 Пропсы
     * @param root0.payload Новое значение таймера
     */
    updateSettings: (state, { payload }: { payload: Partial<ISettings> }) => {
      return {
        ...state,
        settings: {
          ...state.settings,
          ...payload
        }
      };
    },

    /** Ресет настроек */
    resetSettings: () => initialState
  }
});

export const { resetSettings: resetVideoReadingSettings, updateSettings } =
  videoReadingSettingsSlice.actions;
export const { reducer: videoReadingSettingsReducer } =
  videoReadingSettingsSlice;
